var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "getting-started-section py-5" }, [
    _c("div", { staticClass: "container-lg" }, [
      _c("div", { staticClass: "section-header text-center mb-4" }, [
        _c("p", { staticClass: "section-subtitle mb-1" }, [
          _vm._v(_vm._s(_vm.T.homepageHowItWorks)),
        ]),
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_vm.T.homepageGetStartedTitle)),
        ]),
      ]),
      _c("div", { staticClass: "cards-grid" }, [
        _c("div", { staticClass: "getting-started-card" }, [
          _c("div", { staticClass: "card-image-wrapper" }, [
            _c("img", {
              staticClass: "card-image",
              attrs: {
                src: "/media/homepage/contests_section.svg",
                alt: _vm.T.homepageCompeteSectionTitle,
              },
            }),
          ]),
          _c("div", { staticClass: "card-body" }, [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_vm.T.homepageCompeteSectionTitle)),
            ]),
            _c("p", { staticClass: "card-description" }, [
              _vm._v(
                " " + _vm._s(_vm.T.homepageCompeteSectionDescription) + " "
              ),
            ]),
            _c("div", { staticClass: "card-links" }, [
              _c(
                "a",
                { staticClass: "card-link", attrs: { href: "/arena/" } },
                [_vm._v(_vm._s(_vm.T.buttonGoToContests))]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "getting-started-card" }, [
          _c("div", { staticClass: "card-image-wrapper" }, [
            _c("img", {
              staticClass: "card-image",
              attrs: {
                src: "/media/homepage/problems_section.svg",
                alt: _vm.T.homepageTrainSectionTitle,
              },
            }),
          ]),
          _c("div", { staticClass: "card-body" }, [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_vm.T.homepageTrainSectionTitle)),
            ]),
            _c("p", { staticClass: "card-description" }, [
              _vm._v(" " + _vm._s(_vm.T.homepageTrainSectionDescription) + " "),
            ]),
            _c("div", { staticClass: "card-links" }, [
              _c(
                "a",
                { staticClass: "card-link", attrs: { href: "/problem/" } },
                [_vm._v(_vm._s(_vm.T.buttonGoToProblems))]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "getting-started-card" }, [
          _c("div", { staticClass: "card-image-wrapper" }, [
            _c("img", {
              staticClass: "card-image",
              attrs: {
                src: "/media/homepage/create_section.svg",
                alt: _vm.T.homepageCreateSectionTitle,
              },
            }),
          ]),
          _c("div", { staticClass: "card-body" }, [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_vm.T.homepageCreateSectionTitle)),
            ]),
            _c("p", { staticClass: "card-description" }, [
              _vm._v(
                " " + _vm._s(_vm.T.homepageCreateSectionDescription) + " "
              ),
            ]),
            !_vm.isUnder13User
              ? _c("div", { staticClass: "card-links" }, [
                  _c(
                    "a",
                    {
                      staticClass: "card-link",
                      attrs: { href: "/problem/new/" },
                    },
                    [_vm._v(_vm._s(_vm.T.buttonCreateProblem))]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "card-link",
                      attrs: { href: "/contest/new/" },
                    },
                    [_vm._v(_vm._s(_vm.T.buttonCreateContest))]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "getting-started-card" }, [
          _c("div", { staticClass: "card-image-wrapper" }, [
            _c("img", {
              staticClass: "card-image",
              attrs: {
                src: "/media/homepage/courses_section.svg",
                alt: _vm.T.homepageTeachSectionTitle,
              },
            }),
          ]),
          _c("div", { staticClass: "card-body" }, [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_vm.T.homepageTeachSectionTitle)),
            ]),
            _c("p", { staticClass: "card-description" }, [
              _vm._v(" " + _vm._s(_vm.T.homepageTeachSectionDescription) + " "),
            ]),
            _c("div", { staticClass: "card-links" }, [
              _c(
                "a",
                { staticClass: "card-link", attrs: { href: "/course/" } },
                [_vm._v(_vm._s(_vm.T.buttonGoToCourses))]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }